import { Box, Grid, SxProps, Theme } from "@mui/material";
import { UniQuestion } from "../../dao/UniQuestion";
import { useTranslation } from "react-i18next";

type Props = {
  question: UniQuestion;
};

const UcPicture = ({ question }: Props) => {
  const { t } = useTranslation();

  const renderText = () => {
    const componentStyles: SxProps<Theme> = {
      flex: 1,
      textAlign: "center",
      fontSize: {
        xs: "0.5rem",
        sm: "0.75rem",
        md: "1rem",
      },
      fontWeight: "bold",
      p: {
        xs: "4px",
        md: "8px",
      },
      minWidth: "0", // 確保子元素可以縮小
      maxWidth: "100%", // 確保子元素不會超過父容器的寬度
      wordBreak: "break-word",
      overflowWrap: "break-word",
    };

    let descList: Array<string> = [];
    switch (question.question_code) {
      case "身體活動容忍尺度":
        descList = [
          "不痛",
          "可以忽略",
          "可能影響工作",
          "影響工作",
          "影響自主活動能力",
          "完全無法自主活動",
        ];
        break;
      case "關節活動範圍":
        descList = [
          "可自由活動",
          "到極限會痠痛",
          "超過一半會痠痛",
          "只能一半",
          "嚴重受限",
          "完全無法自主活動",
        ];
        break;
      default:
        break;
    }

    if (!descList || descList.length === 0) return null;

    return (
      <Box sx={{ display: "flex", justifyContent: "space-between", px: "8px" }}>
        {descList.map((desc, idx) => (
          <Box sx={componentStyles} key={idx}>
            {t(desc)}
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Grid container sx={{ pt: 0, pb: 0 }} direction={"column"}>
      <Grid item xs={12}>
        <Box>{t(question.question_code)}</Box>
        <img
          src={question.question_title}
          style={{ width: "100%", height: "auto" }}
          alt={question.question_code}
        />
        {renderText()}
      </Grid>
    </Grid>
  );
};

export default UcPicture;
